var _templateObject = _taggedTemplateLiteralLoose(['\n  height: ', ';\n  width: ', ';\n\n  &:focus {\n    outline: none;\n  }\n\n  border: ', ';\n  background-color: ', ';\n'], ['\n  height: ', ';\n  width: ', ';\n\n  &:focus {\n    outline: none;\n  }\n\n  border: ', ';\n  background-color: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from '../../Theme';

export var errorStyles = {
  border: function border(_ref) {
    var errors = _ref.errors,
        touched = _ref.touched,
        name = _ref.name;
    return errors[name] && touched[name] ? '1px solid ' + Theme.colors.danger : '1px solid ' + Theme.colors.pearlGrey;
  },
  background: function background(_ref2) {
    var errors = _ref2.errors,
        touched = _ref2.touched,
        name = _ref2.name;
    return errors[name] && touched[name] && '' + Theme.colors.dangerLight;
  }
};

var TextareaStyled = styled.textarea(_templateObject, function (props) {
  return props.height || '150px';
}, function (props) {
  return props.width || '100%';
}, errorStyles.border, errorStyles.background);

var Textarea = function Textarea(_ref3) {
  var errors = _ref3.errors,
      touched = _ref3.touched,
      name = _ref3.name,
      onChange = _ref3.onChange,
      onBlur = _ref3.onBlur,
      width = _ref3.width,
      height = _ref3.height,
      value = _ref3.value;
  return React.createElement(TextareaStyled, { errors: errors, touched: touched, name: name, onChange: onChange, onBlur: onBlur, width: width, height: height, value: value });
};

Textarea.defaultProps = {
  errors: {},
  touched: {}
};

Textarea.propTypes = process.env.NODE_ENV !== "production" ? {
  errors: PropTypes.object,
  touched: PropTypes.object,
  name: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func

} : {};

export default Textarea;